/** @format */

import React from 'react';
import StatusButton from './StatusButton';
import UserAvatar from './UserAvatar';
import ProfileModal from './ProfileModal';
import { UserGroupContainer, ProfileModalWrapper } from './styles';
import { useUserGroup } from './useUserGroup';
import { CSSTransition } from 'react-transition-group';

const UserGroup = ({ type }) => {
	const {
		RWD,
		aud,
		ref,
		avatars,
		isOpen,
		createStatus,
		pending,
		showAvatar,
		toggleModal,
		handleCreateMeetup
	} = useUserGroup();

	return (
		<UserGroupContainer>
			<StatusButton
				RWD={type ? 'XL' : RWD}
				status={aud}
				createStatus={createStatus}
				pending={pending}
				handleCreateMeetup={handleCreateMeetup}
			/>
			{aud && showAvatar && (
				<div>
					<UserAvatar
						handleClick={toggleModal}
						profileAvatar={avatars && avatars[0]}
						aud={aud}
					/>
					<CSSTransition
						in={isOpen} // 用於判斷是否出現的狀態
						timeout={1000} // 動畫持續時間
						classNames="profile-modal">
						<ProfileModalWrapper ref={ref}>
							{isOpen && <ProfileModal />}
						</ProfileModalWrapper>
					</CSSTransition>
				</div>
			)}
		</UserGroupContainer>
	);
};

export default React.memo(UserGroup);
